import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import * as React from 'react';
import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import selectTimeZoneOption from '../data/mutators/selectTimeZoneOption';
import strings from 'owa-strings/owa-options-strings';
var TimeZoneSelection = /** @class */ (function (_super) {
    tslib_1.__extends(TimeZoneSelection, _super);
    function TimeZoneSelection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectDateFormat = function (item) {
            if (_this.props.onSave) {
                _this.props.onSave(item.key);
            }
            else {
                selectTimeZoneOption(item.key);
            }
        };
        return _this;
    }
    TimeZoneSelection.prototype.render = function () {
        var store = getRegionalOptions();
        return (React.createElement(Dropdown, { label: strings.option_regional_timeZone, options: store.supportedTimeZones.map(function (timeZone) { return ({
                text: timeZone.Name,
                key: timeZone.Value,
            }); }), selectedKey: store.selectedTimeZone || getUserConfiguration().UserOptions.TimeZone, onChanged: this.onSelectDateFormat }));
    };
    TimeZoneSelection = tslib_1.__decorate([
        observer
    ], TimeZoneSelection);
    return TimeZoneSelection;
}(React.Component));
export default TimeZoneSelection;
//# sourceMappingURL=TimeZoneSelection.js.map